import { useMutation, useQuery, useQueryClient } from "react-query";

import { OrderDto } from "doxecure-commons/doxecureClientTypes";
import { $ok } from "foundation-ts/commons";
import { $uint8ArrayFromDataLike } from "foundation-ts/data";
import { Nullable, UUID } from "foundation-ts/types";

import { fetchOrders, downloadInvoicePDF } from "@/services/corporations.service";
import { bytesToDownloadURL } from "@/utils/functions";
import { OrdersID } from "./hooksConstants";
import { useAuthContext } from "./useAuthContext";

export const useOrders = () => {
    const { connectedUser, isAuthenticated } = useAuthContext();
    const queryClient = useQueryClient();

    const corporationApid = connectedUser?.corporations?.first()?.apid;

    const query = useQuery<Nullable<OrderDto[]>>({
        queryKey: [OrdersID, corporationApid],
        queryFn: () => fetchOrders(corporationApid),
        enabled: isAuthenticated && $ok(corporationApid),
        staleTime: 5 * 60 * 1000,
    });

    const invalidate = () => {
        console.log("invalidate orders");
        queryClient.invalidateQueries([OrdersID, corporationApid]);
    };
    
    const downloadInvoice = useMutation({
        mutationFn: async ({orderId, invoiceReference}: {orderId: UUID, invoiceReference: string}) => {
            const data = await downloadInvoicePDF(corporationApid, orderId);
            if (!$ok(data)) { return; }

            const url = bytesToDownloadURL($uint8ArrayFromDataLike(data!), 'application/pdf');
            const link = document.createElement('a');
            link.href = url;
            link.download = `${invoiceReference}.pdf`;
            link.click();
        
            URL.revokeObjectURL(url);
        },
    });

    return {
        ...query,
        downloadInvoice,
        refresh: invalidate
    };
}